import { createContext, useContext } from 'react';
import {
  NotificationSettings,
  DEFAULT_NOTIFICATION_SETTINGS,
} from './types';

interface NotificationContextValue {
  settings: NotificationSettings;
  updateSettings: (settings: Partial<NotificationSettings>) => void;
}

export const NotificationContext = createContext<NotificationContextValue>({
  settings: DEFAULT_NOTIFICATION_SETTINGS,
  updateSettings: () => {},
});

export const useNotificationSettings = () => useContext(NotificationContext);
